/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocalizationSettingsDto } from './LocalizationSettingsDto';
import {
    LocalizationSettingsDtoFromJSON,
    LocalizationSettingsDtoFromJSONTyped,
    LocalizationSettingsDtoToJSON,
    LocalizationSettingsDtoToJSONTyped,
} from './LocalizationSettingsDto';
import type { BusinessAddressDto } from './BusinessAddressDto';
import {
    BusinessAddressDtoFromJSON,
    BusinessAddressDtoFromJSONTyped,
    BusinessAddressDtoToJSON,
    BusinessAddressDtoToJSONTyped,
} from './BusinessAddressDto';
import type { PrimaryContactDto } from './PrimaryContactDto';
import {
    PrimaryContactDtoFromJSON,
    PrimaryContactDtoFromJSONTyped,
    PrimaryContactDtoToJSON,
    PrimaryContactDtoToJSONTyped,
} from './PrimaryContactDto';

/**
 * Customer update data
 * @export
 * @interface UpdateCustomerRequest
 */
export interface UpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    industryType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    companySize?: string;
    /**
     * 
     * @type {PrimaryContactDto}
     * @memberof UpdateCustomerRequest
     */
    primaryContact?: PrimaryContactDto;
    /**
     * 
     * @type {BusinessAddressDto}
     * @memberof UpdateCustomerRequest
     */
    businessAddress?: BusinessAddressDto;
    /**
     * 
     * @type {LocalizationSettingsDto}
     * @memberof UpdateCustomerRequest
     */
    localization?: LocalizationSettingsDto;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateCustomerRequest
     */
    settings?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UpdateCustomerRequest interface.
 */
export function instanceOfUpdateCustomerRequest(value: object): value is UpdateCustomerRequest {
    return true;
}

export function UpdateCustomerRequestFromJSON(json: any): UpdateCustomerRequest {
    return UpdateCustomerRequestFromJSONTyped(json, false);
}

export function UpdateCustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'industryType': json['industry_type'] == null ? undefined : json['industry_type'],
        'companySize': json['company_size'] == null ? undefined : json['company_size'],
        'primaryContact': json['primary_contact'] == null ? undefined : PrimaryContactDtoFromJSON(json['primary_contact']),
        'businessAddress': json['business_address'] == null ? undefined : BusinessAddressDtoFromJSON(json['business_address']),
        'localization': json['localization'] == null ? undefined : LocalizationSettingsDtoFromJSON(json['localization']),
        'settings': json['settings'] == null ? undefined : json['settings'],
    };
}

export function UpdateCustomerRequestToJSON(json: any): UpdateCustomerRequest {
    return UpdateCustomerRequestToJSONTyped(json, false);
}

export function UpdateCustomerRequestToJSONTyped(value?: UpdateCustomerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'company_name': value['companyName'],
        'display_name': value['displayName'],
        'email': value['email'],
        'phone': value['phone'],
        'industry_type': value['industryType'],
        'company_size': value['companySize'],
        'primary_contact': PrimaryContactDtoToJSON(value['primaryContact']),
        'business_address': BusinessAddressDtoToJSON(value['businessAddress']),
        'localization': LocalizationSettingsDtoToJSON(value['localization']),
        'settings': value['settings'],
    };
}

